import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { appConfig, clientConfig } from "../../../shared/constant/app.constant";
import { NavButton } from "../../../shared/components/navigation/next-button.component";
import { AppFlowService } from "../../../shared/services/app-flow/app-flow.service";
import { ReturnOrderService } from "../../../shared/services/return-order/return-order.service";
import { CopyHelpers } from "../../../shared/helpers/copy.helpers";
import { addItemToReturnOrderAction, clearItemsFromReturnOrderAction, loadOrderDataAction, removeItemFromReturnOrderAction, removeTimeStampFromOrderDataAction, updateItemFromReturnOrderAction, updateReturnToAddressFromReturnOrderAction } from "../../../store/actions/order.actions";
import { DeliveryOptionsService, ShippingType } from "../../../shared/services/delivery-options.service";
import { TranslationDataService } from "../../../shared/services/translation-data.service";
import { AddressContact, GetAddressessResponse } from "ClientApp/src/app/shared/models/get-address-response";
import { GetAddressRequest } from "ClientApp/src/app/shared/models/get-address-request";
import { map } from "rxjs/operators";
import { AddressService } from "ClientApp/src/app/shared/services/address.service";
@Component({
  selector: "app-confirm-return",
  templateUrl: "./confirm-return.component.html",
  styleUrls: ["./confirm-return.component.scss"],
})
export class ConfirmComponent implements OnInit, OnDestroy {
  orderData: any;
  refundTotal: any;
  brandInfo: BrandingInfo = {
    logoSrc: clientConfig.LOGO_URL, //this.getSampleBase64Image(),
  };
  nextButton: NavButton = {
    buttonText: "continueButton",
    cssClass: "next-btn",
    isDisable: false
  };

  screenNav: NavButton = {
    buttonText: "Confirm return",
    cssClass: "back-btn",
    number: 3,
  };
  errorinfo = {
    title: "returnNotCreatedSubject",
    message: "returnNotCreatedBody",
  };
  header = "shippingConfirmationHeader";
  returnOrder$: Observable<any>;
  refundDeductionRate: any = null;
  refundDeductionTotal: any = 0;
  displayReasonReturn =
    clientConfig.APPFLOW !== "formPostPrePopulatedOrder" &&
    clientConfig.APPFLOW !== "automaticLoginAppFlow" &&
    !clientConfig.APPFLOW.includes("TechSupportFlow");
  showRefund = clientConfig.SHOW_REFUND === "True";
  displayTechSupport = clientConfig.APPFLOW.includes("TechSupportFlow");
  techSupportResult: any;
  customerServiceNeeded: any[] = [];
  noReturnNeeded: any[] = [];
  showItemsDescription: boolean = false;
  isDGInstructionChecked: boolean = false;
  isDGInstructionChecked2: boolean = false;
  modeOfTransport: any;
  isDangerousGood: boolean = false;
  currentTimeStamp: string;
  UN_NO4 = clientConfig.UN_NO4;
  UN_NO3 = clientConfig.UN_NO3;
  reasons: any[];
  tenantName = clientConfig.TENANTNAME;
  isDangerousGoodsFlag: boolean = false;
  returnReasonsData: any;
  translationSubscription: Subscription;
  useExternalIntegration: boolean = clientConfig.USE_EXTERNAL_INTEGRATION;
  orderAddress: any;

  constructor(
    private appFlowService: AppFlowService,
    private store: Store<AppState>,
    private returnOrderSerice: ReturnOrderService,
    private deliveryOptionsService: DeliveryOptionsService,
    private translationService: TranslationDataService,
    private addressService: AddressService
  ) {
    if (clientConfig.APPFLOW === "formPostPrePopulatedOrder") {
      this.store.dispatch(clearItemsFromReturnOrderAction());
      this.appFlowService.activeStepId = this.appFlowService.getActiveId("returnconfirm");
    }
    else if (clientConfig.APPFLOW === "formPostPrePopulatedOrderTechSupportFlow") {
      this.showItemsDescription = true;
      this.appFlowService.activeStepId = this.screenNav.number;
    }
    else if (this.appFlowService.getActiveAppFlow().steps.includes("techSupport") && clientConfig.APPFLOW === "formPostOrderB2CTechSupportFlow") {
      this.showItemsDescription = true;
      this.appFlowService.activeStepId = this.screenNav.number + 1;
    }
    else {
      this.appFlowService.activeStepId = this.screenNav.number;
    }

    const route = this.appFlowService.findRouteFromSequence("returnconfirm");
    this.nextButton.routeUrl = `/d/${route.next}`;
    this.screenNav.routeUrl = `/d/${route.back}`;
    this.returnOrder$ = this.store.pipe(select("returnOrder"));
    this.store.pipe(select("returnOrder")).subscribe((items) => {
      this.orderData = CopyHelpers.deepCopy(items);
    });
    if (clientConfig.APPFLOW === "formPostPrePopulatedOrder") {
      this.orderData.orderLines.forEach((orderLine) => {
        if (
          (this.orderData.items.findIndex((x) => x.itemNumber === orderLine.itemNumber) === -1 ||
            this.orderData.items.findIndex((x) => x.itemName === orderLine.itemName) === -1) &&
          orderLine.returnable
        ) {
          const newItem = CopyHelpers.deepCopy(orderLine);
          newItem.returnQuantity = newItem.quantityToReturn;
          this.store.dispatch(addItemToReturnOrderAction({ payload: { item: newItem } }));
        }
      });
    }
    if (clientConfig.APPFLOW.includes("TechSupportFlow")) {
      this.store.pipe(select("techSupport")).subscribe((items) => {
        this.techSupportResult = CopyHelpers.deepCopy(items);
      });
      if (this.techSupportResult.items.length != 0) {
        this.orderData.items.forEach((orderline) => {
          this.techSupportResult.items.forEach((value) => {
            if (orderline.itemName.toLowerCase().trim() == value.itemName.toLowerCase().trim() && (value.assessmentResult.toLowerCase().trim() === "customer service needed" || value.assessmentResult.toLowerCase().trim() === "no return needed")) {
              this.store.dispatch(
                removeItemFromReturnOrderAction({
                  payload: { item: CopyHelpers.deepCopy(orderline) },
                })
              );
              if (value.assessmentResult.toLowerCase().trim() === "customer service needed") {
                this.customerServiceNeeded.push(value);
              }
              if (value.assessmentResult.toLowerCase().trim() === "no return needed") {
                this.noReturnNeeded.push(value);
              }
            }
          })
        })
      }
    }

    this.modeOfTransport = this.orderData.modeOfTransport;
    this.modeOfTransport = this.modeOfTransport ? this.modeOfTransport.trim().toUpperCase() : "";
    this.isDangerousGoodsFlag = this.orderData.deliveryOption.isDangerousGoods ? this.orderData.deliveryOption.isDangerousGoods : false;
    if (this.modeOfTransport === "EXPRESS_HV" || this.modeOfTransport === "EXPRESS_LQ" || this.modeOfTransport === "EXPRESS_HD" || this.isDangerousGoodsFlag) {
      this.isDangerousGood = true;
      this.nextButton.isDisable = true;
    }
    else {
      this.isDGInstructionChecked = true;
      this.isDGInstructionChecked2 = true;
    }

    this.refundTotal = 0;
    this.orderData.items.forEach((element: { returnQuantity: number; unitPrice: number; }) => {
      if (element.returnQuantity !== null) {
        this.refundTotal += element.unitPrice * element.returnQuantity;
      }
    });
    this.refundDeductionRate = this.orderData.deductionRate;
    if (this.refundDeductionRate !== undefined && this.refundDeductionRate !== null) {
      this.refundDeductionTotal = Math.fround(this.refundTotal * this.refundDeductionRate * 100);
      this.refundDeductionTotal = this.refundDeductionTotal / 100;
    }

    //Changes for storing reasonReturn for DHL
    if (this.orderData.items && this.tenantName.toLowerCase().trim() == "dhl")
      this.translationService.fetchTranslationData('en-GB');

    this.translationSubscription = this.translationService.translationDataEmitter.subscribe(res => {
      if (res)
        this.returnReasonsData = res.map((reason: string) => reason.trim().toLowerCase());
      if (this.orderData.items && this.tenantName.toLowerCase().trim() == "dhl" && this.returnReasonsData)
        this.updateReturnReasonCodeInStore();
    });
  }

  async ngOnInit() {
    if (this.useExternalIntegration) {
      const receiverAddress = await this.getReceiverAddress();
      var returnToAddress = null;
      if (receiverAddress)
        returnToAddress = this.mapReceiverAddressToReturnToAddress(receiverAddress);
      else
        returnToAddress = this.orderAddress;

      this.store.dispatch(
        updateReturnToAddressFromReturnOrderAction({
          payload: {
            ...returnToAddress
          },
        })
      );
    }
  }

  async getReceiverAddress(): Promise<AddressContact | undefined> {
    const request: GetAddressRequest = {
      senderCode: clientConfig.RETURN_CENTER_ID,
      carrierCode: this.orderData?.deliveryOption?.carrier?.code,
      carrierServiceCode: this.orderData?.deliveryOption?.carrierService?.code,
    };

    try {
      const response = await this.addressService.getAddress(request).pipe(
        map((res: GetAddressessResponse) =>
          res.addressContact?.find(contact => contact.type?.toLowerCase() === 'returnto')
        )
      ).toPromise();

      return response;
    } catch (err) {
      console.warn('Failed to fetch receiver address via AddressBook:', err);
      this.mapOrderAddressToReturnToAddress(this.orderData?.orderAddress);
    }
  }

  mapReceiverAddressToReturnToAddress(receiverAddress: any): any {
    return {
      name: receiverAddress.name ?? null,
      streetAddress: receiverAddress.address?.address1 ?? null,
      streetAddressHouseNumber: receiverAddress.address?.houseNumber ?? null,
      additionalAddressInformation: receiverAddress.address?.address2 ?? null,
      city: receiverAddress.address?.city ?? null,
      isoCountry: receiverAddress.address?.isoCountryAlpha2 ?? null,
      state: receiverAddress.address?.state ?? null,
      zipcode: receiverAddress.address?.postalCode ?? null,
      email: receiverAddress.contact?.email ?? null,
      contactInfo: {
        firstName: receiverAddress.contact?.name ?? null,
        lastName: null,
        email: receiverAddress.contact?.email ?? null,
        phone: receiverAddress.contact?.phoneNumber ?? null
      },
      longitude: receiverAddress.address?.coordinate?.longitude ?? null,
      latitude: receiverAddress.address?.coordinate?.latitude ?? null,
      residential: receiverAddress.address?.residential ?? false,
      vatNumber: receiverAddress.vatNumber ?? null
    }
  }

  mapOrderAddressToReturnToAddress(orderAddress: any): any {
    this.orderAddress = {
      name: orderAddress?.name ?? null,
      streetAddress: orderAddress?.streetAddress ?? null,
      streetAddressHouseNumber: orderAddress?.streetAddressHouseNumber ?? null,
      additionalAddressInformation: orderAddress?.additionalAddressInformation ?? null,
      city: orderAddress?.city ?? null,
      isoCountry: orderAddress?.isoCountry ?? null,
      state: orderAddress?.state ?? null,
      zipcode: orderAddress?.zipcode ?? null,
      email: orderAddress?.email ?? null,
      contactInfo: {
        firstName: orderAddress?.contactInfo?.name ?? null,
        lastName: orderAddress?.contactInfo?.lastName ?? null,
        email: orderAddress?.contactInfo?.email ?? null,
        phone: orderAddress?.contactInfo?.phoneNumber ?? null
      },
      longitude: orderAddress?.longitude ?? null,
      latitude: orderAddress?.latitude ?? null,
      residential: orderAddress?.residential ?? false,
      vatNumber: orderAddress?.vatNumber ?? null
    }
  }

  updateReturnReasonCodeInStore() {
    this.orderData.items.forEach((item) => {
      if (item?.returnReason && (!this.returnReasonsData.includes(item.returnReason?.toLowerCase().trim()))) {
        this.store.dispatch(
          updateItemFromReturnOrderAction({
            payload: {
              item: { returnReason: "Other", reasonForReturn: "Other" },
              itemNumber: item.itemNumber,// Make sure to include the necessary properties to identify the item
            },
          })
        );
      }
    });
  }

  legalApprovedCheckForDG2() {
    this.nextButton.isDisable = !(this.isDGInstructionChecked && this.isDGInstructionChecked2);
  }

  legalApprovedCheckForDG() {
    this.nextButton.isDisable = !(this.isDGInstructionChecked && this.isDGInstructionChecked2);

    const currentDate = new Date();
    this.currentTimeStamp = currentDate.toUTCString();

    if (this.isDGInstructionChecked)
      this.store.dispatch(loadOrderDataAction({ payload: { ...this.orderData, legalApproved: this.currentTimeStamp } }));
    else {
      this.orderData.legalApproved = "";
      this.store.dispatch(removeTimeStampFromOrderDataAction({ payload: { ...this.orderData } }));
    }
  }

  isCollectionType(modeOfTransport) {
    return this.deliveryOptionsService.getTypeByMode(modeOfTransport) === ShippingType.Collection;
  }

  hasPrefferedPickup(modeOfTransport) {
    return this.deliveryOptionsService.getShippingOption(modeOfTransport).preferredPickup;
  }

  handleImageError4(event: any) {
    if (event.target.dataset.errorHandled) {
      return;
    }
    // Handle the error, set a fallback image
    event.target.src = `${appConfig.NG_APP_ROOT}/assets/i18n/images/UN_NO4.png`;

    event.target.dataset.errorHandled = 'true';
  }
  handleImageError3(event: any) {
    if (event.target.dataset.errorHandled) {
      return;
    }
    // Handle the error, set a fallback image
    event.target.src = `${appConfig.NG_APP_ROOT}/assets/i18n/images/UN_NO3.png`;

    event.target.dataset.errorHandled = 'true';
  }

  ngOnDestroy() {
    if (this.translationSubscription) {
      this.translationSubscription.unsubscribe();
    }
  }
}
